import { observable, runInAction } from 'mobx'
import { BaseStore, getOrCreateStore } from '@Di'

export class ComposeStore extends BaseStore {
  @observable mode = null //op
  @observable isOpen = false
  @observable isDirty = false
  @observable isEmpty = true

  startCompose = async (hubId, post, mode) => {
    runInAction(() => {
      this.mode = mode
      this.isOpen = true
    })
  }

  stopCompose = () => {
    runInAction(() => {
      this.isOpen = false
    })
  }
}

export default getOrCreateStore('ComposeStore', ComposeStore)
